<template>
    <main class="admin-page__content">
        <VContentHeaderDefault
            title="Справочники форм"
            button="Создать справочник"
            @search="onSearch"
            @button="onButtonClick"
        ></VContentHeaderDefault>

        <template v-if="isLoading">
            <div class="admin-page__loader">
                <VSpinner></VSpinner>
            </div>
        </template>

        <template v-else>
            <VContentTableDefault
                :rows="rows"
                :page="page"
                :total="total"
                :options="options"
                @page="onPageChange"
                @edit="onEditClick"
                @click="onEditClick"
                @delete="onDelete"
            ></VContentTableDefault>
        </template>

        <VAdminDictionaryCard></VAdminDictionaryCard>
    </main>
</template>
<script>
import VSpinner from '../../components/VProgress/VSpinner.vue';
import VAdminDictionaryCard from '../../modals/VAdminDictionaryCard.vue';
import VContentTableDefault from '../../components/VContentTableDefault.vue';
import VContentHeaderDefault from '../../components/VContentHeaderDefault.vue';
import './AdminPage.scss';

import Vue from 'vue';
import Component from 'vue-class-component';
import { errorMessage } from '../../../js/error';
import { createDictionary, updateDictionary, deleteDictionary, getAllDictionaries } from '../../../js/admin-api';
import { Watch } from 'vue-property-decorator';
import ModalNames from '../../../js/enums/ModalNames';

@Component({
    components: {
        VSpinner,
        VAdminDictionaryCard,
        VContentTableDefault,
        VContentHeaderDefault,
    },
})
class AdminPageDictionaries extends Vue {
    rows = [];
    page = 1;
    total = 1;
    isLoading = true;
    searchString = '';
    options = {
        editable: true,
        deletable: true,
        columns: [
            {
                size: 5,
                label: '№',
                display: (x) => x.id,
            },
            {
                size: 45,
                label: 'Название',
                display: (x) => x.name,
            },
            {
                size: 20,
                label: 'Значений',
                display: (x) => (Array.isArray(x.options) ? x.options.length : 0),
            },
            {
                size: 20,
                label: 'Создан',
                display: (x) => this.$_toLocalDateHistory(x.createdAt),
            },
        ],
    };

    onSearch(searchString) {
        this.searchString = searchString;
    }

    onPageChange(page) {
        this.page = page;
    }

    async onDelete(dictionary) {
        this.isLoading = true;

        try {
            await deleteDictionary(dictionary);

            const index = this.rows.indexOf(dictionary);

            this.rows.splice(index, 1);
        } catch (error) {
            this.$showModal(ModalNames.ERROR, { errorMessage: errorMessage(error) });
        } finally {
            this.isLoading = false;
        }
    }

    async onEditClick(dictionary) {
        try {
            dictionary = await this.$showModal(ModalNames.ADMIN_PANEL_DICTIONARY_CARD, {
                dictionary,
            });

            this.isLoading = true;

            try {
                await updateDictionary(dictionary);
                await this.fetchDictionaries();
            } catch (error) {
                this.$showModal(ModalNames.ERROR, { errorMessage: this.mapError(error) });
            } finally {
                this.isLoading = false;
            }
        } catch (error) {
            // The modal was closed.
            return;
        }
    }

    async onButtonClick() {
        try {
            const dictionary = await this.$showModal(ModalNames.ADMIN_PANEL_DICTIONARY_CARD, {
                dictionary: {
                    name: '',
                    options: [''],
                },
            });

            this.isLoading = true;

            try {
                await createDictionary(dictionary);
                await this.fetchDictionaries();
            } catch (error) {
                this.$showModal(ModalNames.ERROR, { errorMessage: this.mapError(error) });
            } finally {
                this.isLoading = false;
            }
        } catch (error) {
            // The modal was closed.
            return;
        }
    }

    mapError(error) {
        // Laravel's unique rule returns the English default under errors.name; show a Russian message.
        if (error?.response?.data?.errors?.name) {
            return 'Справочник с таким названием уже существует';
        }

        return errorMessage(error);
    }

    @Watch('page')
    @Watch('searchString')
    async fetchDictionaries() {
        this.isLoading = true;

        try {
            const response = await getAllDictionaries(this.page, this.searchString);

            this.rows = response.data.data;
            this.total = response.data.total;
        } catch (error) {
            this.$showModal(ModalNames.ERROR, { errorMessage: errorMessage(error) });
        } finally {
            this.isLoading = false;
        }
    }

    created() {
        this.fetchDictionaries();
    }
}

export default AdminPageDictionaries;
</script>
